export async function registerServiceWorker() {
	if (!("serviceWorker" in navigator)) {
		console.warn("Service workers not supported");
		return null;
	}

	try {
		const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

		console.log("Service Worker registered:", registration);
		return registration;
	} catch (err) {
		console.error("SW registration failed", err);
		return null;
	}
}
